/**
 * Copyright (c) 2017 CRF Box Oy. All Rights Reserved. Company Confidential.
 */

import { FETCHING_PDF, RECEIVE_PDF, CLOSE_DOCUMENT_PDF, ERROR_PDF } from '../actions/actionTypes';

const pdfState = {
  isFetchingPdf: false,
  pdfError: null,
  pdfArrayBuffer: null,
  objectBlob: null
};

const pdfReducer = (state = pdfState, action) => {
  switch (action.type) {
    case CLOSE_DOCUMENT_PDF:
      return Object.assign({}, state, pdfState);
    case FETCHING_PDF:
      return Object.assign({}, state, pdfState, { isFetchingPdf: true });
    case ERROR_PDF:
      return Object.assign({}, state, pdfState, { pdfError: action.payload });
    case RECEIVE_PDF:
      return Object.assign({}, state, pdfState, {
        pdfArrayBuffer: action.payload.pdfArrayBuffer,
        objectBlob: action.payload.objectBlob
      });

    default:
      return state;
  }
};

export default pdfReducer;
